export default "__VITE_ASSET__D3yj_JFB__"